import React, { useEffect, useState } from 'react'
import { Educator } from '../../../../models/_models'
import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';
import UserTypeSelect from './UserTypeSelect';
import defaultUser from '../../../../assets/default-user.jpg';
import Image from '../../../Image/Image'

const StudentRow = ({ student, options, season, userTypeOptions = [] }) => {
  const [teacherId, setTeacherId] = useState();
  const [currentTeacher, setCurrentTeacher] = useState();

  useEffect(() => {
    if (!teacherId) return;

    Educator.find(teacherId).then((res) => {
      setCurrentTeacher(res.data)
    })
  }, [teacherId])

  return (
    <tr id={`student_${student.id}`} className="responsive-width">
      <td style={{ padding: '0px' }}>
        {student.imageUrl ? (
          <Image src={student.imageUrl} classes="img-rounded img-index" useDefaultClass={false} />
        ) : (
          <Image src={defaultUser} classes="img-rounded img-index" useDefaultClass={false} />
        )}
      </td>
      <td style={{ padding: '0px', maxWidth: '150px', wordWrap: 'break-word' }}>
        <InlineInput
          modelId={student.id}
          attributeName="student_id"
          attributeValue={student.studentId}
        />
      </td>
      <td style={{ padding: '0px' }}>
        {student.jobId}
      </td>
      <td style={{ padding: '0px' }}>
        <InlineInput
          modelId={student.id}
          attributeName="first_name"
          attributeValue={student.firstName}
        />
      </td>
      <td style={{ padding: '0px' }}>
        <InlineInput
          modelId={student.id}
          attributeName="last_name"
          attributeValue={student.lastName}
        />
      </td>
      <td style={{ padding: '0px' }} colSpan="2">
        <InlineSelect
          studentId={student.id}
          attributeName="educator_id"
          attributeValue={student.educatorId}
          options={options}
          setTeacherId={setTeacherId}
          season={season}
        />
      </td>

      <td style={{ padding: '0px' }} colSpan="2">
        <InlineInput
          modelId={student.educatorId}
          attributeName="displayName"
          attributeValue={currentTeacher && currentTeacher.displayName || student.teacherDisplayName}
          model="educator"
          initialCurrentModel={currentTeacher}
        />
      </td>

      <td style={{ padding: '0px' }}>
        <InlineInput
          modelId={student.id}
          attributeName="grade"
          attributeValue={student.grade}
        />
      </td>

      <td style={{ padding: '0px' }}>
        <InlineInput
          modelId={student.educatorId}
          attributeName="displayGrade"
          attributeValue={currentTeacher && currentTeacher.displayGrade || student.teacherDisplayGrade}
          model="educator"
          initialCurrentModel={currentTeacher}
        />
      </td>
      <td style={{ padding: '0px' }}>
        <UserTypeSelect
          studentId={student.id}
          value={student.userType}
          options={userTypeOptions}
        />
      </td>
      <td style={{ padding: '0px' }}>
        <InlineInput
          modelId={student.id}
          attributeName="place"
          attributeValue={student.place}
        />
      </td>
    </tr>
  )
};

export default StudentRow
